module.exports = __webpack_public_path__ + "static/scopesecurity-logo-4e59dff83514f92db984a8c34dc8b4c7.png";